<template>
  <Vue3Lottie
    :animationData="animationData"
    :width="props.width"
    :height="props.height"
  />
</template>

<script setup>
import { camelCase } from "lodash";
import { computed } from "vue";
import { Vue3Lottie } from "vue3-lottie";

import InitDataJson from "../../assets/json/init.json";
import LoadingMoreDataJson from "../../assets/json/loading-more.json";

const props = defineProps({
  type: {
    type: String,
    default: "init"
  },
  width: {
    type: Number,
    default: 100
  },
  height: {
    type: Number,
    default: 100
  }
});

const AnimationDataMaps = {
  init: InitDataJson,
  loadingMore: LoadingMoreDataJson
};

const animationData = computed(() => {
  const type = camelCase(props.type);
  return AnimationDataMaps[type] || InitDataJson;
});
</script>
